import DocumentReferencePanel from "./DocumentReferencePanel";

export default DocumentReferencePanel;
